class BarePaceHeroSlider extends HTMLElement {
  #motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  #pausedForReducedMotion = false;

  connectedCallback() {
    this.addEventListener('keydown', this.#handleKeydown);
    this.addEventListener('focusin', this.#handleFocusIn);
    this.addEventListener('focusout', this.#handleFocusOut);
    this.#motionQuery.addEventListener('change', this.#handleMotionPreference);

    customElements.whenDefined('slideshow-component').then(() => {
      if (!this.isConnected) return;
      this.#applyMotionPreference();
    });
  }

  disconnectedCallback() {
    this.removeEventListener('keydown', this.#handleKeydown);
    this.removeEventListener('focusin', this.#handleFocusIn);
    this.removeEventListener('focusout', this.#handleFocusOut);
    this.#motionQuery.removeEventListener('change', this.#handleMotionPreference);
  }

  get slideshow() {
    return this.querySelector('slideshow-component');
  }

  #handleKeydown = (event) => {
    if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

    const target = event.target;
    if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement) {
      return;
    }

    const slideshow = this.slideshow;
    if (!slideshow) return;

    const isRtl = document.documentElement.dir === 'rtl';
    const goNext = event.key === 'ArrowRight' ? !isRtl : isRtl;

    if (goNext) {
      slideshow.next(event);
    } else {
      slideshow.previous(event);
    }
  };

  #handleFocusIn = () => {
    this.slideshow?.suspend();
  };

  #handleFocusOut = (event) => {
    if (event.relatedTarget instanceof Node && this.contains(event.relatedTarget)) return;
    if (this.#motionQuery.matches) return;
    this.slideshow?.resume();
  };

  #handleMotionPreference = () => {
    this.#applyMotionPreference();
  };

  #applyMotionPreference() {
    const slideshow = this.slideshow;
    if (!slideshow?.hasAttribute('autoplay')) return;

    if (this.#motionQuery.matches) {
      this.#pausedForReducedMotion = !slideshow.paused;
      slideshow.pause();
      this.setAttribute('reduced-motion', '');
      return;
    }

    this.removeAttribute('reduced-motion');
    if (!this.#pausedForReducedMotion) return;

    this.#pausedForReducedMotion = false;
    slideshow.paused = false;
    slideshow.resume();
  }
}

if (!customElements.get('barepace-hero-slider')) {
  customElements.define('barepace-hero-slider', BarePaceHeroSlider);
}
